export const PAYOUT_THRESHOLD = 50;
export const PAYOUT_RATE_PER_CONTRIBUTION = 5;
export const SUPPORT_EMAIL = "support@umbaji.org";
export const TEST_TIME_LIMIT = 10 * 60;
export const PHONEME_RECORDING_LIMIT = 5;
export const PHRASE_RECORDING_LIMIT = 15;
export const TRANSLATION_TIME_LIMIT = 15;
export const ITEMS_PER_PAGE = 10;
